import { forwardRef } from 'react'

import classNames from 'classnames'

import './BasicButton.scss'

export type BasicButtonVariant =
  | 'primary'
  | 'outlined'
  | 'danger'
  | 'ghost'
  | 'ghost danger'

export interface BasicButtonProps extends React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> {
  title?: string
  basicVariant?: BasicButtonVariant
  className?: string
  size?: 'sm' | 'md' | 'lg'
  children?: React.ReactNode
}

export const BasicButton = forwardRef<HTMLButtonElement, BasicButtonProps>(
  (
    {
      basicVariant = 'primary',
      title,
      className,
      children,
      disabled,
      size = 'md',
      ...basicButtonProps
    },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        className={classNames(
          'button',
          { disabled: disabled },
          size,
          basicVariant,
          className,
        )}
        disabled={disabled}
        {...basicButtonProps}
      >
        {children ?? title}
      </button>
    )
  },
)

BasicButton.displayName = 'BasicButton'
